import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import ContractorService from "../../../services/ContractorService";
import Breadcrumb from "../../../components/Breadcrumb";
import StorageService from "../../../services/StorageService";
import ListContractor from "../Components/ListContractor";
import ViewModelContractor from "../Components/ViewModelContractor";
import MessageDialog from "../../../components/MessageDialog";

export default function ViewContractor() {
  const [contractors, setContractors] = useState([]);
  const [selected, setSelected] = useState(null);
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("success");
  // const messageTimer = useRef(null);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;


  // VIEW POPUP STATES
  const [showViewModal, setShowViewModal] = useState(false);
  const [viewData, setViewData] = useState(null);

  const navigate = useNavigate();

  const showMessage = (text, type = "success") => {
    setMessage(text);
    setMsgType(type);
    // if (messageTimer.current) clearTimeout(messageTimer.current);
    // messageTimer.current = setTimeout(() => setMessage(""), 4000);
  };

  // const closeMessage = () => {
  //   setMessage("");
  //   if (messageTimer.current) clearTimeout(messageTimer.current);
  // };

  // const fetchContractors = async () => {
  //   setLoading(true);
  //   try {
  //     const res = await ContractorService.getActive();

  //     // handle both array & {data} safely
  //     const list = Array.isArray(res)
  //       ? res
  //       : Array.isArray(res?.data)
  //         ? res.data
  //         : [];

  //     const startIndex = (currentPage - 1) * itemsPerPage;
  //     const endIndex = startIndex + itemsPerPage;
  //     const paginatedData = list.slice(startIndex, endIndex);

  //     setContractors(paginatedData);
  //     setPageCount(Math.ceil(list.length / itemsPerPage));

  //   } catch (err) {
  //     console.error(err);
  //     showMessage("Failed to load contractors", "error");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const fetchContractors = async (page = 1) => {
    setLoading(true);
    try {
      const res = await ContractorService.getActivePaginated(page, itemsPerPage);

      const list = res?.data || [];
      const totalItems = res?.total || 0;

      setContractors(list);
      setPageCount(Math.ceil(totalItems / itemsPerPage));

    } catch (err) {
      console.error(err);
      showMessage("Failed to load contractors", "error");
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchContractors();
  }, [currentPage]);


  // ✅ FIXED: ONLY ACTIVE RECORDS CAN BE SELECTED (inactive checkbox disabled)
  const handleSelect = (id, status) => {
    if (status !== "Active") return; // block inactive selection

    setSelected(
      selected.includes(id)
        ? []
        : [id, status]
    );
  };

  const handleAdd = () => {
    navigate("/cpnl/contractors/add");
  };

  const handleModify = () => {
    if (!selected) {
      showMessage("Please select a contractor to modify.", "error");
      return;
    }

    if (selected.status !== "Active") {
      showMessage("Inactive Records Cannot be Modified", "error");
      return;
    }

    navigate(`/cpnl/contractors/add/${selected.id}`);
  };

  const handleView = async () => {
    if (!selected) {
      showMessage("Please select a contractor to view.", "error");
      return;
    }

    try {
      setLoading(true);
      const res = await ContractorService.getById(selected.id);
      const data = res?.data?.data || res?.data || res;

      if (!data) {
        showMessage("Failed to load contractor details!", "error");
        return;
      }

      setViewData(data);
      setShowViewModal(true);
    } catch (err) {
      console.error(err);
      showMessage("Error loading contractor details", "error");
    } finally {
      setLoading(false);
    }
  };

  const handlePageClick = (event) => {
    const selectedPage = event.selected + 1;
    setCurrentPage(selectedPage);
  };


  const handleToggleStatus = async (contractor) => {
    const newStatus = contractor.status === "Active" ? "Inactive" : "Active";
    const confirmMsg = `Are you sure  do you want to ${newStatus}?`;

    if (!window.confirm(confirmMsg)) return;

    setLoading(true);
    try {
      await ContractorService.updateStatus(contractor.id, {
        status: newStatus,
        updatedBy: 1,
      });
      showMessage(`Contractor changed as ${newStatus}.`, "success");
      fetchContractors();
    } catch (err) {
      console.error(err);
      showMessage("Error updating status", "error");
    } finally {
      setLoading(false);
    }
  };

  const closeViewModal = () => {
    setShowViewModal(false);
    setViewData(null);
  };

  const formatDateTime = (value) => {
    if (!value) return "";
    try {
      return new Date(value).toLocaleString();
    } catch {
      return value;
    }
  };

  const filteredContractors = contractors.filter(
    (c) =>
      c.contractorName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      c.contractorCode?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      <Breadcrumb pageTitle="Contractors" secondTitle="Masters" />

      <div className="row">
        <div className="card py-2 bg-white shadow-sm">
          {/* {message && (
            <div
              className={`alert ${msgType === "success" ? "alert-success" : "alert-danger"
                } d-flex justify-content-between`}
            >
              <span>{message}</span>
              <button
                type="button"
                className="btn-close"
                onClick={closeMessage}
              ></button>
            </div>
          )} */}
          
            <MessageDialog
              message={message}
              type={msgType}
              setMessage={setMessage}
              setMsgType={setMsgType}
            />
        
          <div className="mb-3 pb-2 border-bottom d-flex align-items-end gap-3">
            <div>
              <input
                type="text"
                className="form-control"
                placeholder="Search Contractor"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="ms-auto d-flex gap-2">
              <button
                className="d-inline-flex btn btn-success"
                onClick={handleAdd}
                disabled={loading}
              >
                <i className="ti ti-plus me-1"></i> Add
              </button>

              <button
                className="d-inline-flex btn btn-warning"
                onClick={handleModify}
                disabled={loading}
              >
                <i className="ti ti-pencil me-1"></i> Modify
              </button>

              <button
                className="d-inline-flex btn btn-primary"
                onClick={handleView}
                disabled={loading}
              >
                <i className="ti ti-eye me-1"></i> View
              </button>
            </div>
          </div>

          <ListContractor
            loading={loading}
            contractors={contractors}
            filteredContractors={filteredContractors}
            selected={selected}
            handleSelect={setSelected}
            handleToggleStatus={handleToggleStatus}
            pageCount={pageCount}
            handlePageClick={handlePageClick}
          />
        </div>
      </div>

      <ViewModelContractor
        showViewModal={showViewModal}
        viewData={viewData}
        closeViewModal={closeViewModal}
      />
    </>
  );
}
